<template>
  <collapse-group title="Checklist">
    <div class="task-list-container" v-if="checklistIds && taskChecklistItems.$readyAll">
      <div class="w-100">
        <div style="float: right; line-height: 34px;">
          <!-- Checklist -->
          <strong>{{ itemArrayChecked.length }} / {{ itemsArrayFlat.length - this.newChecklistItem.visible }} complete</strong>
          <font-awesome-icon
            v-tooltip="{ content: taskMeta.hideCompletedItems ? 'Click to show completed items' : 'Click to hide completed items'}"
            class="inline-icon"
            :icon="['fas', taskMeta.hideCompletedItems ? 'eye-slash' : 'eye']"
            color="black"
            @click="updateHideCompletedItems(!taskMeta.hideCompletedItems)" />
          <!-- <div class="sub-title">Planned Duration</div> -->
        </div>
        <div style="display: flex; height: 34px; align-items: center;"
          v-if="taskChecklistItems.$readyAll && taskChecklistItems.itemsAsArray().length > 0">

          <!--
          <font-awesome-icon  :icon="['fas', 'search']" color="black" />
          <inline-editable-text
            v-model="search"
            @input="search = $event"
            :inline="true"
            placeholder="search checklist"
            :hideButtons="true"
            class="task-page-search">
            <div slot-scope="props" >{{props.text}}</div>
          </inline-editable-text>
          -->

          <el-input
            class="task-page__checklist-search"
            size="small"
            placeholder="Type something"
            prefix-icon="el-icon-search"
            v-model="search">
          </el-input>

          <!--
          <div style="display:flex; height: 30px; align-items: center; border-bottom: 2px solid black;">
              <b>&Sigma;</b>: {{ showHoursMinutesSeconds(taskDuration - taskDurationDone) }}
          </div>
          -->
        </div>

        <!--
        @node-drag-over="handleDragOver"
        @node-drag-start="handleDragStart"
        @node-drag-enter="handleDragEnter"
        @node-drag-leave="handleDragLeave"
        @node-drag-end="handleDragEnd"
        -->
        <!-- <pre>{{taskChecklistItems}}</pre> -->
        <!-- <pre>{{itemsArrayTree}}</pre> -->
        <!-- <pre>{{itemArrayChecked}}</pre> -->
        <el-tree
          class="task-checklist-tree "
          :data="itemsArrayTree"
          :props="{
            label: 'name',
            children: 'children'
          }"
          node-key="$id"
          show-checkbox
          draggable
          check-strictly
          icon-class="el-icon-arrow-right"
          @node-drop="handleDrop"
          @check="handleItemCheck"
          @node-collapse="onNodeCollapse"
          @node-expand="onNodeExpand"
          :default-checked-keys="itemArrayChecked"
          :default-expanded-keys="itemArrayExpanded"
          :auto-expand-parent="false"
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
          ref="checklist"
          empty-text="Click 'Add Element' to start building your checklist"
          >
          <div
            slot-scope="{ node, data }"
            class="custom-tree-node"
            @mouseover="setChecklistItemMouseover(data.$id)"
            @mouseleave="setChecklistItemMouseover('')"
            v-show="newChecklistItem.$id !== data.$id  ||
              (newChecklistItem.$id === data.$id &&
              (newChecklistItem.visible || newChecklistItem.visibleFromInit ))
            ">
            <div :class="{
                'custom-tree-node-content': true,
                'custom-tree-node-content--is-url': data.isURL
              }">
              <font-awesome-icon
                v-if="data.$id !== 'newItem'"
                class="drag-handle"
                :icon="['fas', 'grip-vertical']"
                color="black" />
              <!-- v-tooltip="{ content: 'Drag &amp; Drop' }" -->
              <div @click="focusOnEditableText('name-' + data.$id)" class="w-100" >
                <template v-if="newChecklistItem.$id !== data.$id">
                  <div class="task-inline-icons-wrapper">
                    <div>
                      <inline-editable-text
                        @change="updateItemName(data.$id, $event)"
                        @keydownevent="onKeyDown(data, node, $event)"
                        @focus="editing_inline_element = true"
                        @lost-focus="editing_inline_element = false"
                        @blur="editing_inline_element = false"
                        @cancel="editing_inline_element = false"
                        :floating-buttons="false"
                        :value="data.name"
                        :showDragHandle="false"
                        placeholder='Enter new Task'
                        :resetOnUpdate="false"
                        :resetOnCancel="false"
                        :forceBlur="true"
                        :lostFocusIsUpdate="true"
                        :ref="'name-' + data.$id"
                        :lineThrough="(data.done || taskDone) ? true : false"
                        :class="[(search !== '' &&  data.name.toLowerCase().includes(search.toLowerCase())) ? 'task-search-highlight' : '']" >
                      </inline-editable-text>
                    </div>
                    <div class="task-inline-icons">

                      <font-awesome-icon
                        v-if="data.isURL"
                        v-tooltip="{ content: 'Open URL'}"
                        class="inline-icon"
                        style="color: var(--blue)"
                        icon="external-link-alt"
                        @click.stop.prevent="onOpenURL(data.name)" />

                      <font-awesome-icon
                        v-show="newChecklistItem.$id !== data.$id"
                        v-tooltip="{ content: 'Edit item'}"
                        class="inline-icon"
                        :icon="['fas', 'edit']"
                        @click.stop.prevent="focusOnEditableText('name-' + data.$id)" />

                      <font-awesome-icon
                        v-show="newChecklistItem.$id !== data.$id"
                        v-tooltip="{ content: 'Convert to new task (sub items become new checklist)'}"
                        class="inline-icon"
                        icon="magic"
                        @click.stop.prevent="onCreateNewTaskFromChecklistItem(data.$id)" />

                      <font-awesome-icon
                        v-show="newChecklistItem.$id !== data.$id"
                        v-tooltip="{ content: 'Append item below'}"
                        class="inline-icon"
                        :icon="['fas', 'arrow-down']"
                        @click.stop.prevent="() => append(data.parent, '', node)" />

                      <font-awesome-icon
                        v-show="newChecklistItem.$id !== data.$id"
                        v-tooltip="{ content: 'Add new subtask'}"
                        class="inline-icon"
                        :icon="['fas', 'arrow-right']"
                        @click.stop.prevent="() => append(data.$id)" />

                      <font-awesome-icon
                        v-show="data.children.length === 0 && newChecklistItem.$id !== data.$id"
                        v-tooltip="{ content: 'Delete item'}"
                        class="inline-icon"
                        :icon="['fas', 'times']"
                        @click.stop.prevent="() => remove(data.$id)" />

                      <font-awesome-icon
                        v-show="newChecklistItem.$id === data.$id"
                        v-tooltip="{ content: 'Delete item'}"
                        class="inline-icon"
                        :icon="['fas', 'times']"
                        @click.stop.prevent="() => hideNewItem()" />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <inline-editable-text
                      @change="checkCreateInput( $event )"
                      @blur="hideNewItem($event, 'blur')"
                      @cancel="hideNewItem($event, 'cancel')"
                      @lost-focus="hideNewItem($event, 'lost-focus')"
                      :floating-buttons="false"
                      :value="data.name"
                      placeholder= 'Enter new Task'
                      tooltip="Enter new Task"
                      :ref="'name-' + data.$id"
                      :resetOnUpdate="true"
                      :resetOnCancel="true">
                    </inline-editable-text>
                  </div>
              </template>
              </div>
              <div v-if="data.$id !== 'newItem'">
                <duration-quick-settings
                  v-if="!data.done"
                  :ref="'duration-' + data.$id"
                  v-model="data.duration"
                  @save="updateItemDuration(data.$id, $event)"
                  :quickDurationSettings="{
                    '0 min': 0 * 60,
                    '1 min': 1 * 60,
                    '3 min': 3 * 60,
                    '5 min': 5 * 60,
                    '10 min': 10 * 60,
                    '15 min': 15 * 60,
                    '20 min': 20 * 60,
                    '25 min': 25 * 60,
                    '30 min': 30 * 60,
                    '45 min': 45 * 60,
                    '60 min': 60 * 60
                  }">
                  <!-- {{ showHoursMinutesSeconds(data.duration) }} -->
                  <TaskPageChecklistTimer
                    :timeRemaining="data.duration"
                    :taskId="taskMeta.$id"
                    @timerStopped="updateItemDuration(data.$id, $event)"/>
                </duration-quick-settings>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </div>
    <div v-else>
      Loading...

      <!--
      <pre class="mini-pre">{{taskChecklistItems}}</pre>
      <pre class="mini-pre">{{checklistIds}}</pre>
      <pre class="mini-pre">{{task_ready}}</pre>
      -->
    </div>

    <div style="display: flex; justify-content: space-between;" class="mt-2">
      <el-button style="font-weight: bold; color: #409eff" @click="append('0')">
        <font-awesome-icon icon="plus" class="mr-1" />
        Add Element
      </el-button>
      <div>
        <div style="border-top: 2px solid black" class="pt-2 pb-1">
          <b>&Sigma;</b>: {{ checklistDuration - checklistDurationDone | hoursMinutesSeconds }}
        </div>
      </div>
    </div>
  </collapse-group>
  <!-- <pre class="mini-pre">{{newChecklistItem}}</pre> -->
  <!-- <pre>itemsArrayTree: {{ itemsArrayTree }}</pre> -->
  <!-- <pre>this.itemsArrayFlat: {{ this.itemsArrayFlat }}</pre> -->
</template>

<script>
import listToTree from 'list-to-tree-lite'
import util from "@/util";
import clonedeep from 'lodash.clonedeep';
import { mapActions } from "vuex";
import TaskPageChecklistTimer from "@/components/TaskPage/Elements/TaskPageChecklistTimer"

// import TaskAttachmentMixin from '@/components/Mixins/TaskAttachment'
// import TaskManagementMixin from "@/components/Mixins/TaskManagement"
// import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"

export default {
  name: "TaskPageChecklist",
  props: {
    taskMeta: { required: true },
    memberId: { required: true },
    goalId: { required: true },
    taskIsVolatile: {},
    checklistIds: { default: null },
  },
  // mixins: [ TaskAttachmentMixin, TaskManagementMixin, ConfirmDeletePromptMixin ],
  data: () => ({
    selectedChecklistItemId: '',
    newChecklistItem: {
      $id: 'newItem',
      name: '',
      parent: '0',
      sortidx: 1,
      disabled: true,
      visible: false,
      visibleFromInit: false,
      children: []
    },
    search: '',
    task_ready: false, // ???
    editing_inline_element: false,
  }),
  watch: {
    itemsArrayFlat(newItemsArrayFlat, oldItemsArrayFlat) {
      if (newItemsArrayFlat && newItemsArrayFlat.length > 1) {
        this.newChecklistItem.visibleFromInit = false
      }
      if (newItemsArrayFlat && newItemsArrayFlat.length === 0) {
        this.newChecklistItem.visibleFromInit = true
      }
      if ((!oldItemsArrayFlat ||  oldItemsArrayFlat.length === 0) && newItemsArrayFlat && newItemsArrayFlat.length === 1) {
        this.newChecklistItem.visible = true
      }
    },
    checklistIds: {
      handler( idConfig ) {
        if ( idConfig === null ) {
          return
        }
        this.taskChecklistModel = this.$models.taskChecklistItem.with({
          goalId: idConfig.goalId,
          taskId: idConfig.taskId,
          uid:    idConfig.memberId,
        })
        this.task_ready = true;
      },
      deep: true,
      immediate: true,
    },
    checklistFinishedAllItems: {
      handler(value) { this.$emit('checklist-finished', value ); },
      immediate: true,
    },
    checklistDuration: {
      handler(value) { this.$emit('update-duration', value ); },
      immediate: true,
    },
    checklistDurationDone: {
      handler(value) { this.$emit('update-duration-done', value ); },
      immediate: true,
    },
  },
  computed: {
    taskChecklistItems() {
      if ( this.task_ready && this.taskChecklistModel) {
        return this.taskChecklistModel.subscribeList()
      } else {
        return { $readyAll: false }
      }
    },

    taskDone() {
      if (this.taskMeta.$ready) {
        return this.taskMeta.done
      } else {
        return false
      }
    },

    itemsArrayTree() {
      if (this.itemsArrayFlat) {
        var newArray = clonedeep(this.itemsArrayFlat)
          .filter(item => {
            return !this.taskMeta.hideCompletedItems
              || item.done === false
              || item.$id === "newItem"
          })
        return listToTree(newArray, { idKey: '$id' })
      } else {
        return null
      }
    },

    itemsArrayTreeFlat() {
      function flat(array) {
        var result = [];
        array.forEach(a => {
          result.push(a);
          if (Array.isArray(a.children)) {
            result = result.concat(flat(a.children));
          }
        });
        return result;
      }

      if (this.itemsArrayTree) {
        return flat(this.itemsArrayTree)
      } else {
        return null
      }
    },

    itemsArrayFlat() {
      if (this.taskChecklistItems.$readyAll) {
        let itemsArrayFlat = this.taskChecklistItems
          .itemsAsArray()
          .filter(item => item.name)
          .map(item => {
            return {
              $id: item.$id,
              ...item.$state,
              isURL: util.isURL(item.name)
            };
          })

        if (this.newChecklistItem.visible || this.newChecklistItem.visibleFromInit ) {
          itemsArrayFlat = [...itemsArrayFlat, this.newChecklistItem]
        }

        return itemsArrayFlat.sort(util.sorter.by_sortidx)
      } else {
        return null
      }
    },

    itemArrayChecked() {
      if (this.taskChecklistItems.$readyAll) {
        return this.taskChecklistItems
          .itemsAsArray()
          .filter(item => item.done)
          .map(item => item.$id)
      } else {
        return []
      }
    },

    itemArrayExpanded() {
      if (this.taskChecklistItems.$readyAll) {
        return this.taskChecklistItems
          .itemsAsArray()
          .filter(item => !item.collapse)
          .map(item => item.$id)
      } else {
        return []
      }
    },

    checklistDuration() { // Used externally!
      let taskDuration = 0
      if (this.itemsArrayFlat) {
        this.itemsArrayFlat.forEach(item => {
          if (!isNaN(item.duration)) {
            taskDuration += item.duration
          }
        })
      }
      return taskDuration
    },

    checklistDurationDone() { // Used externally!
      let taskDurationDone = 0
      if (this.itemsArrayFlat) {
        this.itemsArrayFlat.forEach(item => {
          if (!isNaN(item.duration) && item.done) {
            taskDurationDone += item.duration
          }
        })
      }
      return taskDurationDone
    },

    checklistFinishedAllItems() { // Used externally!
      return !this.taskDone
        && this.itemArrayChecked.length > 0
        && this.itemArrayChecked.length === (this.itemsArrayFlat.length - this.newChecklistItem.visible);
    },
  },
  methods: {
    ...mapActions('session', [
      'session_timer_start',
      'session_timer_pause',
      'session_timer_stop',
      'session_timer_reset'
    ]),

    task_meta_update(payload) { // doppelt
      /* Overwrites mixin method! */
      console.log("task meta update: mixin");
      if (this.taskIsVolatile ) {
        this.taskMeta.write().then(() => {
          this.taskMeta.update(payload) // Testing
          this.taskIsVolatile = false;
        })
        return
      }
      if (this.task_ready) {
      // TODO: Check this.taskMeta.access.allow_to_edit_tasks
        this.taskMeta.update(payload)
      }
    },

    onKeyDown(data, node, $event) {
      let id = data.$id
      let index = this.itemsArrayTreeFlat.findIndex(function(item) {
        return item.$id === id;
      });
      if ($event.key === 'ArrowDown' && !$event.ctrlKey) {
        if (this.itemsArrayTreeFlat.length > index + 1) {
          this.$refs['name-' + this.itemsArrayTreeFlat[index + 1].$id].focus(false)
        }
      } else if ($event.key === 'ArrowUp' && !$event.ctrlKey) {
        if (index > 0) {
          this.$refs['name-' + this.itemsArrayTreeFlat[index - 1].$id].focus(false)
        }
      } else if ($event.key === 'ArrowDown' && $event.ctrlKey) {
        this.append(data.parent, '', node)
      } else if ($event.key === 'ArrowRight' && $event.ctrlKey) {
        this.append(data.$id)
      } else if ($event.key === 'ArrowUp' && $event.ctrlKey) {
        let sortidx = ''
        if (index > 0) {
          if (this.itemsArrayTreeFlat[index - 1].parent === data.parent) {
            sortidx = (this.itemsArrayTreeFlat[index - 1].sortidx + data.sortidx) / 2
          } else {
            sortidx = data.sortidx - 1
          }
        } else {
          sortidx = data.sortidx - 1
        }

        this.newChecklistItem.parent = data.parent
        this.newChecklistItem.sortidx = sortidx
        this.newChecklistItem.visible = true
        this.$nextTick(() => {
          if (this.$refs['name-newItem']) {
            this.$refs['name-newItem'].focus()
          }
        })
      }
    },

    setChecklistItemMouseover(itemId) {
      this.selectedChecklistItemId = itemId
    },
    hideNewItem(text, reason) {
      console.log('hideNewItem', 'text:', clonedeep(text), reason)

      if ( reason === 'lost-focus' ) {
        this.newChecklistItem.name = text;
      }

      this.$nextTick(() => {
        if (this.$refs['name-newItem']) {
          // this.$refs['name-newItem'].focus(false) --> focus(false) ??
        }
      })
      this.newChecklistItem.visible = false
    },
    handleDragStart(node, ev) {
      //console.log('drag start', node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      //console.log('tree drag enter: ', dropNode.name);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      //console.log('tree drag leave: ', dropNode.name);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      //console.log('tree drag over: ', dropNode.name);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      //console.log('tree drag end: ', dropNode && dropNode.name, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // console.log('tree drop: ')
      // console.log('draggingNode',draggingNode)
      // console.log('dropNode', dropNode)
      // console.log('dropType', dropType)
      // console.log('ev' ,ev);
      if (dropType === 'new task before') {
        console.log('move task to start')
      }
      console.log('handleDrop',draggingNode, dropNode, dropType, ev)
      let newSortidx = this.getSortidx(dropNode, dropType)
      console.log('this.getSortidx(dropNode.$id)', newSortidx)
      if (dropType !== 'inner' && draggingNode.parent !== dropNode.parent) {
        this.taskChecklistModel.update( draggingNode.data.$id, {
          parent: dropNode.data.parent,
          sortidx: newSortidx
        })
      } else if (dropType === 'inner') {
        this.taskChecklistModel.update( draggingNode.data.$id, {
          parent: dropNode.data.$id,
          sortidx: 1
        })
      }
    },
    handleItemCheck(item) {
      // console.log('handleItemCheck', item.$id)
      this.taskChecklistModel.update( item.$id, { done: !item.done })
      let done = !item.done

      if (done) {
        this.$notify.success({
          type: 'success',
          message: 'Checklist item completed. Nice work!'
        });
        /*if (item.duration > 0) {
          this.task_meta_update({ durationDone: this.taskDurationDone, durationRemaining: Math.max(0, this.taskMeta.durationRemaining - item.duration) })
        }*/
        this.taskChecklistModel.update( item.$id, { done: true })
      } else {
        /*if (item.duration > 0) {
          this.task_meta_update({ durationDone: this.taskDurationDone, durationRemaining: Math.max(0, this.taskMeta.durationRemaining + item.duration) })
        }*/
        this.taskChecklistModel.update( item.$id, { done: false })
      }

      this.$refs.checklist.setChecked(item, !done);
    },

    onNodeCollapse(item) {
      // console.log('handleItemCheck', item.$id)
      this.taskChecklistModel.update( item.$id, { collapse: true })
      return true
    },

    onNodeExpand(item) {
      // console.log('handleItemCheck', item.$id)
      this.taskChecklistModel.update( item.$id, { collapse: false })
      return true
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.toLowerCase().indexOf(value) !== -1;
    },

    append(parentId, name, dropNode) {
      // console.log('parentId', parentId)
      let allSortidxOfParent = this.getAllSortidxForParent(parentId);
      // console.log('allSortidxOfParent', allSortidxOfParent)
      let sortidx = 1
      if (dropNode) {
        sortidx = this.getSortidx(dropNode, 'after')
        // console.log('getSortidx', sortidx, dropNode)
      } else {
        if (allSortidxOfParent.length > 0 ) {
          sortidx = allSortidxOfParent[allSortidxOfParent.length - 1] + 1
        }
      }

      // console.log('allSortidxOfParent', allSortidxOfParent, sortidx)

      this.newChecklistItem.parent = parentId
      this.newChecklistItem.sortidx = sortidx
      this.newChecklistItem.visible = true

      // console.log('this.newChecklistItem 2', this.newChecklistItem)
      this.$nextTick(() => {
        // console.log('name-newItem: trying to focus', this.$refs)
        if (this.$refs['name-newItem']) {
          // console.log('name-newItem: element found')
          this.$refs['name-newItem'].focus()
        }
      })
    },

    checkCreateInput(input) {
      if (typeof input === 'string' || input instanceof String) {
        if (input.length > 0) {
          let lines = clonedeep(input.split("\n"))
          if (lines.length === 1) {
            this.createItem(lines[0])
          } else if (lines.length > 1) {
            let timeoutDistance = 0
              lines.forEach(inputLine => {
                setTimeout(() => {
                  this.createItem(inputLine)
                },
                timeoutDistance)
                timeoutDistance += 10
              })
          }
        }
      }
    },

    createItem(name) {

      let result = util.matchUserInputDuration( name )
      let itemWithDuration = result.match;
      let itemDuration = result.duration;
      let itemName = result.text
      console.log("matchUserInputDuration", result);

      let newItem = clonedeep(this.newChecklistItem) // TODO: Nicht erforderlich

      let newTaskItem = null
      if (itemWithDuration) {
        newTaskItem = {
          // id: util.get_new_uuid(), // TODO: kann raus
          name: itemName,
          parent: newItem.parent,
          sortidx: newItem.sortidx,
          duration: itemDuration
        };
      } else {
        newTaskItem = {
          // id: util.get_new_uuid(), // TODO: kann raus
          name: itemName,
          parent: newItem.parent,
          sortidx: newItem.sortidx
        };
      }

      this.itemsArrayFlat.push(newTaskItem);
      this.taskChecklistModel.add( newTaskItem )

      /* Task does not exist yet and must be created now */
      if ( this.taskIsVolatile ) {
        this.task_meta_update({});
      }

      // get sortidx for next item

      let newSortidx = 1
      let allSortidxOfParent = this.getAllSortidxForParent(newItem.parent)

      let arrayPosition = allSortidxOfParent.findIndex(
        function isLargeNumber(element) {
          return element === newItem.sortidx;
        }
      )
      // console.log('newItem.sortidx', newItem.sortidx)
      // console.log('allSortidxOfParent', allSortidxOfParent)
      // console.log('arrayPosition', arrayPosition)

      if (allSortidxOfParent.length === 0 || allSortidxOfParent.length === 1) {
        newSortidx = newItem.sortidx + 1
      } else {
        if (arrayPosition === 0 ) {
          if (allSortidxOfParent.length > 1) {
            newSortidx = newItem.sortidx + 1
          } else {
            newSortidx = (newItem.sortidx + allSortidxOfParent[0]) / 2
          }
        } else if (arrayPosition === allSortidxOfParent.length - 1 )  {
          newSortidx = newItem.sortidx + 1
        } else {
          newSortidx = (newItem.sortidx + allSortidxOfParent[arrayPosition] ) / 2 + 1
        }
      }
      this.newChecklistItem.sortidx = newSortidx
      // this.newChecklistItem.name = ''
      this.$nextTick(() => {
        if (this.$refs['name-newItem']) {
          this.$refs['name-newItem'].focus()
        }
      })

    },
    updateHideCompletedItems(val ) {
      this.task_meta_update( { hideCompletedItems: val })
    },
    updateItemName(itemId, name ) {
      this.taskChecklistModel.update( itemId, { name: name })
    },
    updateItemDuration(itemId, duration ) {
      console.log('updateItemDuration', duration)
      if (this.taskChecklistModel.sortidx) {
        this.taskChecklistModel.update( itemId, { duration: duration })
      }
    },
    remove(itemId) {
      this.taskChecklistModel.remove( itemId )
    },
    getSortidx(dropNode, dropType) {
      let sortidxDropNode = dropNode.data.sortidx
      // console.log('sortidxDropNode', sortidxDropNode)
      let allSortidxOfParent = this.getAllSortidxForParent(dropNode.data.parent)

      // console.log('getAllSortidxForParent', allSortidxOfParent)
      let arrayPosition = allSortidxOfParent.findIndex(
        function isLargeNumber(element) {
          return element === sortidxDropNode;
        }
      )

      // console.log('position in array', arrayPosition)
      if (allSortidxOfParent.length === 1) {
        if (arrayPosition === 0 && dropType === 'before') {
          return allSortidxOfParent[0] / 2
        } else if (arrayPosition === 0 && dropType === 'after') {
          return allSortidxOfParent[0] + 1
        }
      } else {
        if (arrayPosition === 0 && dropType === 'before') {
          console.log('getSortidx marker 1')
          return allSortidxOfParent[0] / 2
        } else if (arrayPosition === 0 && dropType === 'after') {
          return (allSortidxOfParent[0] + allSortidxOfParent[1]) / 2
        }  else if (arrayPosition === allSortidxOfParent.length - 1 && dropType === 'before' )  {
          console.log('getSortidx marker 2')
          return (allSortidxOfParent[arrayPosition - 1] + allSortidxOfParent[arrayPosition]) / 2
        } else if (arrayPosition === allSortidxOfParent.length - 1 && dropType === 'after' )  {
          return allSortidxOfParent[arrayPosition] + 1
        } else if (dropType === 'after' ) {
          return (allSortidxOfParent[arrayPosition] + allSortidxOfParent[arrayPosition + 1]) / 2
        } else if (dropType === 'before' ) {
          console.log('getSortidx marker 3', arrayPosition)
          return (allSortidxOfParent[arrayPosition - 1] + allSortidxOfParent[arrayPosition]) / 2
        }
      }
    },

    getAllSortidxForParent(parentId) {
      if (this.taskChecklistItems.$readyAll) {
        return clonedeep(this.itemsArrayFlat)
          .filter(item => item.parent === parentId)
          .map(item => item.sortidx)
          .sort()
      } else {
        return []
      }
    },

    onOpenURL(url) {
      console.log("onOpenURL", url)
      var win = window.open(url, '_blank');
      win.focus();
    },

    focusOnEditableText(refId) {
      // console.log('focusOnEditableText', refId)
      if (this.$refs[refId]) {
        this.$refs[refId].focus()
      }
    },

    showHoursMinutesSeconds(seconds) {
      if (seconds > 0) {
        return util.showHoursMinutesSeconds(seconds  * 1000)
      } else {
        return '0 min'
      }
    },

    onCreateNewTaskFromChecklistItem( checklistItemId ) {

      // TODO: Allow to select differnt goal / commitment
      // TODO: Update sortidx?

      const USE_ROOT_NODE_AS_NEW_CHECKLIST_ROOT_NODE = false;

      let root_tree_node = this.itemsArrayTreeFlat.find(item => item.$id === checklistItemId)

      let checklist_item_id_list = []
      const traverse_tree = ( node ) => {
        checklist_item_id_list.push( node.$id )
        if ( node.children && node.children.length > 0 ) {
          node.children.forEach(child => {
            traverse_tree( child )
          })
        }
      }
      traverse_tree( root_tree_node )

      let checklist_items_insert = {}
      checklist_item_id_list.forEach( id => {
        let item = this.itemsArrayFlat.find(item => item.$id === id) || null
        if ( !item ) {
          return
        }
        if ( !USE_ROOT_NODE_AS_NEW_CHECKLIST_ROOT_NODE &&
          item.$id === root_tree_node.$id ) {
          return
        }
        checklist_items_insert[ item.$id ] = {
          name:     item.name,
          parent:   item.parent,
          done:     item.done,
          duration: item.duration,
          sortidx:  item.sortidx,
          // collapse: item.collapse,
        };
        if ( !USE_ROOT_NODE_AS_NEW_CHECKLIST_ROOT_NODE &&
          item.parent === root_tree_node.$id ) {
          checklist_items_insert[ item.$id ].parent = "0"
        }
      })

      if ( USE_ROOT_NODE_AS_NEW_CHECKLIST_ROOT_NODE ) {
        // Update parent id to become new root id
        checklist_items_insert[ checklist_item_id_list[0] ].parent = "0"
      }

      console.log("root_tree_node", root_tree_node)
      console.log("checklist_item_id_list", checklist_item_id_list)
      console.log("checklist_items_insert", checklist_items_insert)

      let memberId = this.memberId;

      this.$prompt('Please input task title', 'Create new task', {
         // confirmButtonText: 'OK',
         // cancelButtonText: 'Cancel',
        inputValue: root_tree_node.name,
        closeOnClickModal: false,
        //inputValue: root_tree_node.name + '!' + this.$filters.hoursMinutes(root_tree_node.duration), TODO: implement duration
      }).then(({ value }) => {

         // Create new task
        let data = {
          name: value,
          description: 'Task was copied from "' + this.taskMeta.name + '"',
          // Set sortidx, otherwise we can not obtain a sortidx,
          // since task list is not loaded in all cases
          sortidx: this.taskMeta.sortidx + 20, // TODO
        }

        return this.$api.task_create_user({
          goal_id:   this.goalId,
          parent_id: this.taskMeta.laneId, // TODO
          member_id: memberId,
          data:      data,
        });

      }).then((new_task_id) => {

        console.log("new_task_id", new_task_id, this.goalId)

        // Create new checklist items in new task
        return this.$models.taskDetails
          .with({ goalId: this.goalId, uid: memberId })
          .update(new_task_id, { checklist: checklist_items_insert })

      }).then(() => {

        // Delete checklist old items
        return this.$models.taskChecklistItem
          .with({ goalId: this.goalId, uid: memberId, taskId: this.taskMeta.$id, })
          .remove( checklist_item_id_list, false )

      }).then(() => {

        // Show notification
        this.$message({
          message: 'Task successfully created',
          type: 'success'
        });

      }).catch((e) => {

        // Handle error
        if ( e !== 'cancel') {
          this.$message.error(e.message);
          console.error(e);
        }

      });
    }
  },
  components: {
    TaskPageChecklistTimer
  }
};
</script>

<style>
.task-checklist-tree.el-tree {
  background: rgba(255, 255, 255, 0.1);
}
.task-checklist-tree .el-tree-node {
  /* border: 1px solid cyan; */
  margin: 0;
  padding: 0;

  /* fix position of marker, so it looks like above and below position are the same */
  margin-top: -2px;

  /* Highlight helper element for element code */
  /* background-color: rgba(0,0,255,0.1); */
}
.task-checklist-tree .el-tree-node .el-tree-node__content {
  border-top: 1px solid #b7b7b7;
  border-bottom: 1px solid #b7b7b7;
  /* margin: 5px; */
  /* padding: 5px; */
  align-items: stretch;

  /* Fix spacing between drag handle and arrow */
  padding-left: 20px;
}
.task-checklist-tree .el-tree-node .el-tree-node__children {
  margin-top: 1px;
  /* margin-top: -15px; */
  /* border: 1px solid red; */
  /* margin: 5px; */
  /* padding: 5px; */
}
.custom-tree-node {
  /* border: 1px solid red; */
  height: auto;
  flex: 1;
  font-size: 16px;
  padding-right: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
}
.custom-tree-node-content {
  display: flex;
  /* justify-content: flex-start; */
  justify-content: space-between;
  align-items: center;
  /* align-items: center; */
  width: 100%;
  /* border: 2px solid red !important; */
  margin: 0;
  padding-left: 4px;
  margin-left: 4px;
  text-overflow: ellipses;
}
.custom-tree-node-content--is-url .inline-editable-text {
  color: var(--blue);
}
.task-checklist-tree .custom-tree-node {
  /* border: 1px solid blue; */
  /* height: 50px; */
}
.task-checklist-tree .el-tree-node__content {
  /* border: 1px solid green !important;
  height: 50px; */

  /* Use this element as anchor for the drag handle position */
  position: relative;

  /* Overwrite/Unset element ui default height */
  height: auto;
}
.task-checklist-tree .el-checkbox__input {
  /* Fix wrong height of parent span */
  line-height: 0.8;
}
.task-checklist-tree .el-checkbox__input .el-checkbox__inner {
  width: 22px;
  height: 22px;
}
.task-checklist-tree .el-checkbox__input.is-checked .el-checkbox__inner {
  border-radius: 100%;
}
.task-checklist-tree {
  clear: both;
}
.task-checklist-tree .el-tree-node__content > .el-checkbox {
  /* since flex stretch does not work for checklist */
  margin: 0;
  display: flex;
  align-items: center;
}
.task-checklist-tree .el-checkbox {
}
.task-checklist-tree .el-tree-node.is-drop-inner .custom-tree-node-content {
  /* background-color: #ffffff !important; */
  background-color: rgba(64, 158, 255, 1) !important;
  color: white !important;
}
.task-checklist-tree .el-checkbox__input.is-checked .el-checkbox__inner,
.task-checklist-tree .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #67c23a;
  /* border-color: #67c23a; */
  border-color: rgb(23, 81, 24);
}
.task-checklist-tree .el-checkbox__inner::after {
  border-bottom: 3px solid white;
  border-right: 3px solid white;
  height: 11px;
  left: 7px;
  top: 2px;
  width: 4px;
  /* bottom: 1px; (REBASE 10.3.2019)*/
}
.task-checklist-tree .el-checkbox__inner:hover {
  border-color: #67c23a;
}

.task-checklist-tree .el-tree__drop-indicator {
  height: 5px;
  z-index: 99999;
}
.task-list-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  /* margin-top: 2em */
}
.task-checklist-tree .el-tree-node__expand-icon {
  font-size: 16pt;
  margin-left: 18px;
  padding: 5px;

  /* Show border for helper object that is used for marker position calculation internally */
  /*
  border: 1px solid green !important;
  margin: -1px;
  */
}
.task-checklist-tree .el-tree-node:not(.is-expanded) .el-tree-node__content {

  /* HACK: Fix double line bug */
  /* border-bottom: 1px solid white; */
  margin-bottom: 1px;
}
.task-checklist-tree .el-tree-node__expand-icon.expanded {
}
.task-checklist-tree .el-tree-node__expand-icon:not(.expanded) {
}
.task-checklist-tree .task-inline-icons-wrapper {
  position: relative;
  margin-right: 0.75em;
}

.task-checklist-tree .task-inline-icons {
  display: none;
  align-items: center;
  justify-content: space-between;
  /* -- neu -- */
  border: 1px solid #838dc5;
  border-radius: 3px;
  background: #ededf7d6;

  /* -- DAS IST ABSICHT! -- */
  position: absolute;
  right: 0;
  top: -2px;
  /*transform: translateY(-50%);*/
  padding-top: 1px;
  padding-bottom: 1px;
}
.task-checklist-tree .custom-tree-node:hover .task-inline-icons {
  display: flex;
  /*display: block;*/
}
.task-checklist-tree .drag-handle {
  /* border: 1px solid green; */
  color: #a0a0a0;
  position: absolute;
  left: 10px;
  /* padding-left: 0.5em;padding-right: 0.5em */
}
.task-checklist-tree .el-tree-node__content:hover .drag-handle {
  color: #000000;
}
.task-checklist-tree .inline-icon:hover {
  /*color: var(--red);*/
}
.task-checklist-tree .inline-icon {
  margin-left: 0.15em;
  margin-right: 0.15em;
  /*color: black;*/
  /*padding: 0;*/
  /* margin-right: 2em; */
}
/*
.task-page-search {
  color: #777777;
  font-style: italic;
  font-weight: normal;
  margin-left: 1em
}
*/
.task-search-highlight {
  color: rgb(64, 158, 255);
  font-weight: bold;
}
.custom-tree-node-content__unsaved {
  font-size: 9pt;
  color: gray;
  float: right;
  margin-left: 0.3em;
}
.task-checklist-tree .el-tree-node__content:hover {
  background-color: #c5ceda59;
}
.task-checklist-tree .el-tree-node:focus > .el-tree-node__content {
  background-color: #9cacc159;
}
.task-checklist-tree .custom-tree-node-content svg {
  outline: none;
}
.task-page__checklist-search .el-input__inner {
  border: none;
  background-color: transparent !important;
}
</style>
